/*
functions to be used throughout the project
*/

// is the value integer?
function isInt(value) {
  var x;
  return isNaN(value) ? !1 : (x = parseFloat(value), (0 | x) === x);
}

// is the value numeric?
function isNumber(value) {
  var x;
  return isNaN(value) ? !1 : (x = parseFloat(value) || parseFloat(value) == 0);
}

// transforms date to sql format
function yyyymmdd(date) {
	 var yyyy = date.getFullYear().toString();
   var mm = (date.getMonth()+1).toString(); // getMonth() is zero-based
   var dd  = date.getDate().toString();
   return yyyy + '-' + (mm[1]?mm:"0"+mm[0]) + '-' + (dd[1]?dd:"0"+dd[0]); // padding
}

// from TX2558 makes TX00002558
function fullRingNumber(rn) {
	var regex = /^([1-9]{0,1}[a-zA-Z]+)0*([1-9][0-9]*)$/i;     
	var match = regex.exec(rn);
	if (match != null){
		var type = match[1];
		var nr = match[2];
	  var nzeroes = 11 - type.length - nr.length;
	  var fullnr = type + Array(nzeroes).join('0') + nr;
	  return fullnr;
	} else {
		return null;
	}
}


// from TX2558 makes [TX,2558]
function dissectRingNumber(rn) {
	var regex = /^([1-9]{0,1}[a-zA-Z]+)0*([1-9][0-9]*)$/i;     
	var match = regex.exec(rn);
	if (match != null){
		var type = match[1];
		var nr = match[2];
		return Array(type,nr);
	} else {
		return null;
	}
}

// from TX2558 makes [TX2558,TX02558]
function ringNumberLeadingZeroes(rn) {
	var regex = /^([1-9]{0,1}[a-zA-Z]+)0*([1-9][0-9]*)$/i;     
	var match = regex.exec(rn);
	if (match != null){
		var type = match[1];
		var nr = match[2];
		var orig = type + nr;
		var zero = type + '0' + nr;
		return Array(orig,zero);
	} else {
		return null;
	}
}